import { z } from 'zod';
/** Sort direction shared by every list endpoint. */
export const sortDirectionSchema = z.enum(['asc', 'desc']);
/**
 * Base pagination query shared by every list endpoint. `sort` is left as a
 * free string here; each resource narrows it to an enum of its sortable
 * columns by overriding the field on top of this schema.
 */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    sort: z.string().optional(),
    direction: sortDirectionSchema.default('desc'),
});
/** Envelope returned by every list endpoint (§12 of the API spec). */
export function paginated(item) {
    return z.object({
        items: z.array(item),
        page: z.number().int(),
        pageSize: z.number().int(),
        totalItems: z.number().int(),
        totalPages: z.number().int(),
    });
}
//# sourceMappingURL=common.js.map